import Vue from "vue";
import VueRouter from "vue-router";
import NewHome from "../views/NewHome.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: NewHome
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../components/AboutComponent.vue")
  },
  {
    path: "/services",
    name: "services",
    component: () =>
      import(
        /* webpackChunkName: "services" */ "../components/ServicesComponent.vue"
      )
  },
  {
    path: "/contact",
    name: "contact",
    component: () =>
      import(
        /* webpackChunkName: "contact" */ "../components/ContactComponent.vue"
      )
  }
];

const router = new VueRouter({
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
